const r=r=>void 0===r?[]:Array.isArray(r)?r:[r];export{r as asArray};
